import {toEuroString} from "../../string-functions";
import dayjs from "dayjs";
import {ApplicationStages, MortgageTypes} from "../../../../models";

export default function (mortgage, config) {
	let items = [
		{
			"name": "3yr-fixed",
			"type": "CHECK",
			"page": 1
		},
		{
			"name": "aip-conditions-in-order-no",
			"type": "CHECK",
			"page": 1
		},
		{
			"name": "aip-conditions-in-order-yes",
			"type": "CHECK",
			"page": 1
		},
		{
			"name": "aip-expiry-date",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "client-names",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "date",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "drawdown-date",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "gifts-amount",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "intermediary-name",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "loan-amount",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "mortgage-account-number",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "property-100years-no",
			"type": "CHECK",
			"page": 1
		},
		{
			"name": "property-100years-yes",
			"type": "CHECK",
			"page": 1
		},
		{
			"name": "purchase-price",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "savings-account-1",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "savings-account-2",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "savings-account-3",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "savings-account-4",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "shares-amount",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "solicitor-address",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "solicitor-name",
			"type": "TEXT",
			"page": 1
		},
		{
			"name": "term-confirmation",
			"type": "TEXT",
			"page": 1
		}
	]
	let map = {}
	let fill = {}
	let ask = []
	const isFixedTerm = (n) => {
		let x = mortgage.activeSubmission?.finalFixedTerm || mortgage.activeSubmission?.provisionalFixedTerm

		if (Number(x) === Number(n)) {
			return true
		}
        return false
		return (mortgage.activeSubmission?.finalProduct || mortgage.activeSubmission?.provisionalProduct || mortgage.requirement.lenderProduct).includes(` ${n} years`)
	}
	const dateFormat = "D MMM YYYY"
	const section1 = () => {
		let d = dayjs()
		map['date'] = d.format(dateFormat)
		map['intermediary-name'] = "Suss'd Mortgages"
		map['mortgage-account-number'] = mortgage.activeSubmission?.mortgageAccountNo
		map['client-names'] = mortgage.applicationTitle
		map['purchase-price'] = mortgage.property.propertyValue.toLocaleString('en-US')
		map['loan-amount'] = (mortgage.activeSubmission?.finalLoan || mortgage.activeSubmission?.provisionalLoan || mortgage.requirement.loanAmount).toLocaleString('en-US')
		map['3yr-fixed'] = isFixedTerm(3)
		map['4yr-fixed'] = isFixedTerm(4)
		map['5yr-fixed'] = isFixedTerm(5)
		map['7yr-fixed'] = isFixedTerm(7)
		map['10yr-fixed'] = isFixedTerm(10)
		map['15yr-fixed'] = isFixedTerm(15)
		map['20yr-fixed'] = isFixedTerm(20)
		map['25yr-fixed'] = isFixedTerm(25)
		map['30yr-fixed'] = isFixedTerm(30)
		map['term-confirmation'] = (mortgage.activeSubmission?.finalTerm || mortgage.activeSubmission?.provisionalTerm || mortgage.requirement.term) + " years"
		if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0) {
            const section = mortgage.uploadSections.find(it => it.name.endsWith('-gift-letter') && it.stage === ApplicationStages.PREAPPROVAL)
			const sum = section ? section.sumOfActiveUploads : 0
            map['gifts-amount'] = toEuroString(sum || 0)
		}
		if (mortgage.property.propertyAge === '>100') {
			map['property-100years-yes'] = true
		}
		else {
			map['property-100years-no'] = true
		}
		map['solicitor-name'] = mortgage.solicitor.firmName
		map['solicitor-address'] = mortgage.solicitor.firmAddress
		if (mortgage.activeSubmission?.aipExpiryDate) {
			map['aip-expiry-date'] = dayjs(mortgage.activeSubmission?.aipExpiryDate).format(dateFormat)
		}
		if (mortgage.activeSubmission?.drawdownDate) {
			map['drawdown-date'] = dayjs(mortgage.activeSubmission?.drawdownDate).format(dateFormat)
		}

	}
	const savings = () => {

		const section = mortgage.mortgageUploads.preapproval.find(it => it.name === 'proof-of-deposit')
        const proofOfDepositInBank = mortgage.uploadSections.find(it => it.name === 'proof-of-deposit')
        const activePODUploads = proofOfDepositInBank ? proofOfDepositInBank.activeUploads : []

		const uploads = section.verified.uploads.active
        activePODUploads.forEach((it,i) => {
            const details = it.values
            map[`savings-account-${i+1}`] = details.documentDate.format('DD MMM YYYY') + '.......' + details.bankName
            map[`balance-${i+1}`] = toEuroString(details.closingBalance)
        })
        // uploads.forEach((it, i) => {
		// 	const details = it.verified.values
		// 	map[`savings-account-${i+1}`] = details.description
		// 	map[`balance-${i+1}`] = toEuroString(details.closingBalance)
		// })
        const bookingDepositReceipt = mortgage.uploadSections.find(it => it.name === 'deposit-receipt')
        const activeBookingDepositReceipts = bookingDepositReceipt ? bookingDepositReceipt.activeUploads : []
         activeBookingDepositReceipts.forEach((it,i) => {
            const details = it.values
            let j = uploads.length + i
            map[`savings-account-${j+1}`] = 'Booking Deposit Paid'
            map[`balance-${j+1}`] = toEuroString(details.amount)
        })
        const properties = mortgage.twoApplicants ? [...(mortgage.applicant1.properties || []), ...(mortgage.applicant2.properties || [])] : mortgage.applicant1.properties || []
        const sellingProperties = properties.filter(it => it.toBeSold)
        let totalProfit = 0;
        const savingSoFarCount = Object.keys(map).filter(it => it.startsWith('savings-account-')).length
        sellingProperties.forEach((prop,i) => {
            const profit = (prop.estimatedValue || 0) - (prop.outstanding || 0);
            totalProfit += profit;
        })
        if (totalProfit > 0) {
            map[`savings-account-${savingSoFarCount+1}`] = 'Proceeds from Sale of Property'
            map[`balance-${savingSoFarCount+1}`] = toEuroString(totalProfit)
        }

        // const section2 = mortgage.mortgageUploads.preapproval.find(it => it.name === 'deposit-receipt')
		// const uploads2 = section2.verified.uploads.active
		// uploads2.forEach((it, i) => {
		// 	let j = uploads.length + i
		// 	const details = it.verified.values
		// 	map[`savings-account-${j+1}`] = 'Booking Deposit Paid'
		// 	map[`balance-${j+1}`] = toEuroString(details.amount)
		// })
		// console.log({section})
		// const getSavings = (n) => {
		// 	const items = []
		// 	const allStatements = mortgage[`applicant${n}`].verifiedAccounts;
		// 	if (allStatements.hasOwnProperty('€')) {
		// 		const statements = allStatements['€']
		// 		statements.dataSource.filter(it => !it.excluded && it.closingBalance > 5000).forEach(it => {
		// 			let person = it.applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName
		// 			items.push( {
		// 				name: `${person}: ${it.account}`,
		// 				balance: it.closingBalance
		// 			})
		// 		})
		// 	}
		// 	const allInvestmentStatements = mortgage[`applicant${n}`].verifiedInvestments;
		// 	if (allInvestmentStatements.hasOwnProperty('€')) {
		// 		const investments = allInvestmentStatements['€']
		// 		investments.dataSource.filter(it => !it.excluded && it.closingBalance > 5000).forEach(it => {
		// 			let person = it.applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName
		// 			items.push( {
		// 				name: `${person}: ${it.account}`,
		// 				balance: it.closingBalance
		// 			})
		// 		})
		// 	}
		// 	console.log({items})
		// 	return items
		// }
		// const savings = getSavings(1)
		// if (mortgage.twoApplicants) {
		// 	savings.push(...getSavings(2))
		// }
		// savings.forEach((it, i) => {
		// 	map[`savings-account-${i+1}`] = it.name
		// 	map[`balance-${i+1}`] = toEuroString(it.balance)
		// })
		// console.log({savings})
	}
	const conditions = ()=>{
		ask.push({
			name: 'conditions-reason',
			label: 'Conditions Not Met Reason',
			type: 'TEXTAREA',
			group: 'CONDITIONS'
		})
		if (config.hasOwnProperty('conditions-reason') && config['conditions-reason'] !==""){
			map['aip-conditions-in-order-no'] = true
			map['conditions-reason'] = config['conditions-reason']
		}
		else{
			map['aip-conditions-in-order-yes'] = true
		}

	}
	section1()
	if (mortgage.mortgageType !== MortgageTypes.REFINANCE){
		savings()
	}

	conditions()
	return {
		sections: [
			{
				map,
				fill,
				ask
			}
		]
	}

}